import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { NgxSkeletonLoadingComponent } from '@digipay/ngx-skeleton-loading';
import { ApiImageModule } from '@digipay/ng-ui-api-image';
import { Store, StorePaymentMethodMapper, StoreType } from '@client-monorepo/daily-fintech/stores';
import { ActionHandlerService, ActionType } from '@client-monorepo/common/action-handler';
import { AnalyticsEventType, EventManagementService } from '@client-monorepo/common/event-management';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { Router } from '@angular/router';

@Component({
  selector: 'stores-applet-store-overview',
  standalone: true,
  imports: [CommonModule, NgxBadgeModule, NgxSkeletonLoadingComponent, ApiImageModule, NgxButtonComponent],
  templateUrl: './store-overview.component.html',
  styleUrl: './store-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoreOverviewComponent {
  router = inject(Router);
  store = input<Store>();
  isBlurred = input<boolean>(false);
  hasWebsite = computed<boolean | undefined>(() => {
    return !!this.store()?.types.includes(StoreType.ONLINE);
  });
  hasShop = computed<boolean | undefined>(() => {
    return !!this.store()?.types.includes(StoreType.ONSITE) && this.showBranchesButton();
  });
  isDisabled = computed(() => this.store()?.state?.disabled);
  showBranchesButton = input(false);

  StorePaymentMethodMapper = StorePaymentMethodMapper;

  actionHandler = inject(ActionHandlerService);
  eventManagementService = inject(EventManagementService);

  goToWebsite(): void {
    this.eventManagementService.triggerEventImmediately({
      type: AnalyticsEventType.REDIRECT,
      to: (this.store()?.landingUrl as string) ?? (this.store()?.url as string),
      meta: {
        host: this.store()?.url as string,
      },
      breadCrumbs: ['stores-overview', 'store-landing'],
    });
    this.actionHandler.handle({
      type: ActionType.REDIRECT,
      payload: {
        url: (this.store()?.landingUrl as string) ?? (this.store()?.url as string),
        params: {
          external: true,
          'dp-source': 'DP',
          'dp-medium': 'merchant',
          'dp-type': 'merchant',
        },
      },
    });
  }

  goToBranches(): void {
    this.router.navigate(['stores', this.store()?.trackingCode, 'branches']);
  }
}
